import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CMSFactory from 'factories/CMS'
import ProductFactory from 'factories/Products'
import PubSub from 'services/PubSub/'
import StorageService from 'services/StorageService'
import TagManagerService from 'services/TagManager'
import Link from 'components/Link'
import ProductControls from 'components/ProductControls'
import ProductPrices from 'components/ProductPrices'
import ImageLoad from 'components/ImageLoad'
import Average from 'components/Reviews/Average'
import ProductFlags from 'components/ProductFlags'
import FavoriteButton from 'components/FavoriteButton'
import TimerProduct from './TimerProduct'
import { translateFlag } from 'config/constants'
import { features } from 'config'
import notImage from 'images/foto_en_preparacion.png'
import { useLogged } from 'hooks'
import SalesChannel from 'services/SalesChannel'
import { slugify, getImageV2 } from 'utils'
import { sizeProductImage, actionsType } from 'config/constants';
import { withRouter } from "react-router";
import AddToListButton from './AddToListButton'
import style from './style.scss' //NOSONAR

const ShelfProduct = (props) => {
    const { callback, notPDP, product, callbackAddToCart } = props

    let categoriesIds =
        product &&
        product.categoriesIds &&
        product.categoriesIds.length &&
        product.categoriesIds[0].split('/').filter(Boolean).slice(-1).pop()
    let idCategory = categoriesIds

    let qtyInit = props.qtyInit ? props.qtyInit * 1 : 0
    const item = product.items ? product.items[0] : false
    const sku = item.itemId
    let controlsConfig = null
    const sc = SalesChannel.getSalesChannel()

    const [load, setLoad] = useState(null)

    const isLogged = useLogged(false)

    if (item) {
        controlsConfig = {
            unitSale: product['Pesable x Unidad'] && product['Pesable x Unidad'][0] ? translateFlag[product['Pesable x Unidad'][0]] : false,
            unitMultiplier: item.unitMultiplier,
            measurementUnit: item.measurementUnit,
            maxItems: item.maxItems - (item.inCart ? item.inCart : 0),
            maxItemsOrigin: item.maxItems,
            customClass: props.small ? props.small : false,
            tagManagerData: { product: product, listTitle: props.listTitle, position: props.position },
        }
    }

    const gtmWithoutStock = () => {
        if (!stock && item) {
            let storeName = StorageService.getItem('store_name')
            if (!storeName) {
                storeName = 'Jumbo Chile'
            }
            TagManagerService.productWithoutStock(storeName + ' - ' + props.listTitle, item.itemId, item.name)
        }
    }


    const hasStock = (_item) => {
        if (!_item) return false
        const commertialOffer = _item.sellers && _item.sellers[0] ? _item.sellers[0].commertialOffer : false
        return !!(
            commertialOffer &&
            commertialOffer.ListPrice !== 0 &&
            commertialOffer.AvailableQuantity &&
            commertialOffer.AvailableQuantity > 0
        )
    }

    const openModalAddToList = (itemID) => {
        if(props?.history?.location?.pathname.includes('/mi-carro')){
            PubSub.dispatch(actionsType.DRAWER.UPSELLING_CART_CLOSE)
            PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { skuId: itemID, config: controlsConfig })
        }else{
            PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { skuId: itemID, config: controlsConfig })
        }

    }

    const producRedirect = () => {
        PubSub.dispatch('product_redirect')
    }

    const productClick = () => {
        TagManagerService.productClick(props.product, props.listTitle, props.position)

        StorageService.setItem('list_pdp', props.listTitle)
    }

    const callbackLoading = (loading) => {
        setLoad(loading)
    }

    const openDrawer = () => {
        const _categoryIds =
            product && product.categoriesIds && product.categoriesIds.length && product.categoriesIds[0].split('/').filter(Boolean)
        let categoryParent = null
        _categoryIds.forEach((_category) => {
            if (idCategory != _category) {
                categoryParent = _category
            }
        })
        PubSub.dispatch('drawer_similar_products_open', { skuId: sku, categoryId: idCategory, categoryParent: categoryParent })

        TagManagerService.interaction(sc + ' - ' + 'Productos Similares PLP', sku + ' - ' + item.name, 'Click: Ver Similares')
    }

    const goToBrand = (brand) => {
        const formatBrand = slugify(brand);
        props.history.push(`/${formatBrand}`);
        TagManagerService.interaction("Click Marca", brand, product?.categories[0]);
    }


    const skuData = item && product.SkuData && product.SkuData[item.itemId] ? product.SkuData[item.itemId] : {}
    const productImageMobile = item ? getImageV2(item,   sizeProductImage.mobile) : product.ImageUrl
    const productImageDesktop = item ? getImageV2(item,   sizeProductImage.desktop) : product.ImageUrl
    const link = notPDP ? '#' : product.linkText ? `/${product.linkText}/p` : ''
    const stock = item ? hasStock(item) : false

    const dateServer = item && item.date_server ? item.date_server : new Date().getTime()
    const dateEnd = CMSFactory.milliseconds(item.end_date)
    const dateInit = CMSFactory.milliseconds(item.start_date)
    const productName = product.productName || product.ProductName
    if (item) {
        item.skuData = item.skuData || {}
    }

    const imageResponsive = {
        768: productImageMobile,
        1440: productImageDesktop
    };
    
    const unitMeasurement = item ? ProductFactory.formatWeight(item.measurementUnit, item.unitMultiplier) : ''
    const exclusiveJumbo = product && product['Exclusivo Jumbo'] && product['Exclusivo Jumbo'][0] === 'Sí' ? product['Exclusivo Jumbo'][0] : null;
    const countryFlag = product && product['Origen'] && (product['Origen'][0] === 'EEUU') ? product['Origen'][0] : null

    return (
        <div className="shelf-product-island">
            <div className="shelf-product-top-island" onClick={() => producRedirect()}>
                <div className="shelf-product-buttons-wrap">
                    <FavoriteButton sku={sku} position={props.position} type={'tooltip_favorite_plp'} />
                    <AddToListButton openModalAddToList={openModalAddToList} itemId={item.itemId} productId={product.Id}/>
                </div>
                <div className="shelf-product-image-island">
                    {!load}
                    <Link
                        to={link}
                        onClick={productClick}
                        className={
                            'shelf-wrap-image ' +
                            (!isLogged ? ' not-logged ' : '') +
                            (!stock && features.personalize ? ' image-out-of-stock' : '')
                        }
                        aria-label={productName}>
                        {productImageDesktop && (
                            <ImageLoad
                                src={productImageDesktop}
                                srcSet={imageResponsive}
                                errorImage={notImage}
                                alt={productName}
                                gtmData={props.gtmData}
                                callback={gtmWithoutStock}
                            />
                        )}
                        {!productImageDesktop && (
                            <ImageLoad
                                src={notImage}
                                errorImage={notImage}
                                alt={productName}
                                gtmData={props.gtmData}
                                callback={gtmWithoutStock}
                            />
                        )}
                    </Link>
                </div>
                <div className="container-shelf-info-product">
                    <div className="shelf-info-product">
                        {item && <ProductFlags item={item} nutritionalTag={true} stock={stock} exclusiveJumbo={exclusiveJumbo} countryFlag={countryFlag}/>}
                        <a onClick={(()=> goToBrand(product?.brand))} title={product?.brand} className="shelf-product-brand">
                            <h2 className="shelf-product-brand">{product?.brand}</h2>
                        </a>
                        <Link to={link} onClick={productClick} title={productName} className="shelf-product-title">
                            <h2 className='shelf-product-title-text'>{productName}</h2>
                        </Link>
                        {!!item.unitMultiplier && <span className="shelf-single-unit">{unitMeasurement}</span>}
                    </div>
                    {!!qtyInit && <span className="shelf-product-init">Solicitado {qtyInit} un</span>}
                </div>
            </div>

            {!!stock && <ProductPrices item={item} skuData={skuData} onlyCurrentPrice={true} productDetail={false} />}
            {item.time && !!stock && <TimerProduct dateToday={dateServer} dateInit={dateInit} dateEnd={dateEnd} />}
            {!!stock && (
                <div className="shelf-product-bottom-btns">
                    <ProductControls
                        item={item}
                        id={item.itemId}
                        config={controlsConfig}
                        quantity={item.quantity}
                        inCart={item.inCart}
                        qtyInit={qtyInit}
                        callback={callback}
                        callbackLoading={callbackLoading}
                        callbackAddToCart={callbackAddToCart}
                        exclusiveJumbo={exclusiveJumbo}
                    />
                </div>
            )}
            {product && product.productId && <Average comment={false} single={true} productId={product.productId} disableComments={true}/>}
            {!stock && (
                <div className="no-stock">
                    {!features.personalize ? (
                        <>
                            <i className="font-icn alert" />
                            <span className="no-stock-text">Sin Stock</span>
                        </>
                    ) : (
                        <button className="secundary-btn" onClick={openDrawer}>
                            Ver similares
                        </button>
                    )}
                </div>
            )}
        </div>
    )
}

ShelfProduct.propTypes = {
    product: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number,
    item: PropTypes.object,
    limitTitle: PropTypes.number,
    callback: PropTypes.func,
    qtyInit: PropTypes.string,
    notPDP: PropTypes.bool,
    gtmData: PropTypes.object,
    favorites: PropTypes.array,
    callbackAddToCart: PropTypes.func,
}

export default withRouter(ShelfProduct)
